import { render, staticRenderFns } from "./GeneralInstitutionBalance.vue?vue&type=template&id=648cf747"
import script from "./GeneralInstitutionBalance.vue?vue&type=script&lang=js"
export * from "./GeneralInstitutionBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648cf747')) {
      api.createRecord('648cf747', component.options)
    } else {
      api.reload('648cf747', component.options)
    }
    module.hot.accept("./GeneralInstitutionBalance.vue?vue&type=template&id=648cf747", function () {
      api.rerender('648cf747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/GeneralInstitutionBalance.vue"
export default component.exports